export var MODE;
(function (MODE) {
  MODE[MODE["Edit"] = 1] = "Edit";
  MODE[MODE["Create"] = 0] = "Create";
})(MODE || (MODE = {}));
export var CGI_TYPE;
(function (CGI_TYPE) {
  CGI_TYPE[CGI_TYPE["NormalHttp"] = 1] = "NormalHttp";
  CGI_TYPE[CGI_TYPE["Gw123Http"] = 2] = "Gw123Http";
  CGI_TYPE[CGI_TYPE["ScfHttp"] = 3] = "ScfHttp";
  CGI_TYPE[CGI_TYPE["Wuji1_0"] = 4] = "Wuji1_0";
  CGI_TYPE[CGI_TYPE["Sql"] = 5] = "Sql";
  CGI_TYPE[CGI_TYPE["Code"] = 6] = "Code";
  CGI_TYPE[CGI_TYPE["FrontEndHttp"] = 7] = "FrontEndHttp";
  CGI_TYPE[CGI_TYPE["CustomGwHttp"] = 8] = "CustomGwHttp";
  CGI_TYPE[CGI_TYPE["ER"] = 9] = "ER";
})(CGI_TYPE || (CGI_TYPE = {}));
export var DNS_TYPE;
(function (DNS_TYPE) {
  DNS_TYPE[DNS_TYPE["Polaris"] = 0] = "Polaris";
  DNS_TYPE[DNS_TYPE["L5"] = 1] = "L5";
  DNS_TYPE[DNS_TYPE["DNS"] = 2] = "DNS";
})(DNS_TYPE || (DNS_TYPE = {}));
/** 新的寻址用字符串做索引 */
export var AddressType;
(function (AddressType) {
  AddressType["Polaris"] = "Polaris";
  AddressType["DNS"] = "DNS";
  AddressType["L5"] = "L5";
  AddressType["PolarisWithService"] = "PolarisWithService";
  AddressType["DefaultPolaris"] = "defaultPolaris";
  AddressType["DefaultDns"] = "defaultDNS";
})(AddressType || (AddressType = {}));
export var AddressIndexType;
(function (AddressIndexType) {
  // 使用项目的公共寻址
  AddressIndexType["Project"] = "project";
  // 使用接口独立的自定义寻址
  AddressIndexType["Interface"] = "interface";
})(AddressIndexType || (AddressIndexType = {}));
export var MockDataFormat;
(function (MockDataFormat) {
  MockDataFormat[MockDataFormat["JSON"] = 0] = "JSON";
  MockDataFormat[MockDataFormat["CODE"] = 1] = "CODE";
})(MockDataFormat || (MockDataFormat = {}));
export const AuthType = {
  SIMPLE: 'SIMPLE',
  ANONYMOUS: 'ANONYMOUS'
};
//# sourceMappingURL=ICgiOption.js.map
